var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'card-container',style:({
    '--background': _vm.background,
    '--color': _vm.color
  })},[_c('span',{staticClass:"name"},[_c('span',[_vm._v(_vm._s(_vm.name))]),(_vm.tooltipCode)?_c('AftTooltip',{staticStyle:{"margin-left":"8px"},attrs:{"code":_vm.tooltipCode}}):_vm._e()],1),_c('span',[_vm._v(_vm._s(_vm.value))]),_c('svg-icon',{staticClass:"icon",attrs:{"icon-class":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }